import axios from '@/lib/axios'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { BetaFeatureOrganizationQueryKey } from './beta-features.query'
import type {
  OrganizationBetaFeatures,
  UpdatedOrganizationBetaFeature,
  UpdateOrganizationBetaFeatureInput,
} from './beta-features.types'

export async function getOrganizationBetaFeatures({
  queryKey: [{ organizationId }],
}: Pick<QueryFunctionContext<BetaFeatureOrganizationQueryKey>, 'queryKey'>) {
  return (
    (await axios.get<OrganizationBetaFeatures>(
      `/organizations/${organizationId}/beta-features`
    )) || { features: [] }
  )
}

export async function updateOrganizationBetaFeature({
  organizationId,
  featureKey,
  enabled,
}: UpdateOrganizationBetaFeatureInput) {
  return axios.put<UpdatedOrganizationBetaFeature>(
    `/organizations/${organizationId}/beta-features/${featureKey}`,
    { enabled }
  )
}
